<template>
  <div class="login-container">
    <!-- 网站logo区域，点击可返回首页 -->
    <a href="/" class="logo-area">
      <div class="logo">
        <img src="@/assets/img/logo.png" alt="Logo" />
      </div>
      <div class="system-name">小微融资机制平台</div>
    </a>
    <!-- 登录表单区域 -->
    <div class="login-form">
      <!-- 登录方式切换 -->
      <div class="login-tabs">
        <div
          :class="['tab-item', activeTab === 'password' ? 'active' : '']"
          @click="activeTab = 'password'"
        >
          密码登录
        </div>
        <div
          :class="['tab-item', activeTab === 'code' ? 'active' : '']"
          @click="activeTab = 'code'"
        >
          验证码登录
        </div>
      </div>

      <!-- 密码登录表单 -->
      <el-form
        v-if="activeTab === 'password'"
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        class="form"
      >
        <el-form-item prop="username">
          <el-input
            v-model="passwordForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入手机号或身份证号"
          ></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="passwordForm.password"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="请输入密码"
            @keyup.enter.native="handlePasswordLogin"
            show-password
          ></el-input>
        </el-form-item>

        <div class="remember-forgot">
          <router-link to="/forget" class="forgot-password"
            >忘记密码?</router-link
          >
        </div>

        <el-button
          type="primary"
          class="login-button"
          :loading="loading"
          @click="handlePasswordLogin"
          >立即登录</el-button
        >
      </el-form>

      <!-- 验证码登录表单 -->
      <el-form
        v-if="activeTab === 'code'"
        ref="codeForm"
        :model="codeForm"
        :rules="codeRules"
        class="form"
      >
        <el-form-item prop="username">
          <el-input
            v-model="codeForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>

        <el-form-item prop="verifyCode">
          <div class="verify-code-container">
            <el-input
              v-model="codeForm.verifyCode"
              prefix-icon="el-icon-message"
              placeholder="请输入验证码"
              @keyup.enter.native="handleCodeLogin"
            ></el-input>
            <el-button
              type="primary"
              :disabled="isSending"
              @click="sendVerifyCode"
              >{{ sendBtnText }}</el-button
            >
          </div>
        </el-form-item>

        <div class="remember-forgot">
          <router-link to="/forget" class="forgot-password"
            >忘记密码?</router-link
          >
        </div>

        <el-button
          type="primary"
          class="login-button"
          :loading="loading"
          @click="handleCodeLogin"
          >立即登录</el-button
        >
      </el-form>

      <div class="register-link">
        <span>还没有账号？</span>
        <router-link to="/register">立即注册</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// 导入token操作工具函数
import { setToken, getToken } from "@/utils/auth";
// 导入API接口函数
import { pwdLogin, codeLogin, getCaptcha } from "@/api";
export default {
  name: "Login", // 组件名称
  data() {
    // 用户名验证函数
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号或身份证号"));
      } else {
        // 验证手机号或身份证号格式
        const isPhone = /^1[3-9]\d{9}$/.test(value);
        const isIdCard = /^\d{17}[\dXx]$/.test(value);
        if (isPhone || isIdCard) {
          callback();
        } else {
          callback(new Error("请输入正确的手机号或身份证号"));
        }
      }
    };

    // 密码验证函数
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };

    // 验证码验证函数
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入验证码"));
      } else if (value.length !== 6) {
        callback(new Error("验证码为6位数字"));
      } else {
        callback();
      }
    };

    return {
      activeTab: "password", // 当前激活的登录方式，默认为密码登录

      // 密码登录表单数据
      passwordForm: {
        username: "", // 用户名
        password: "", // 密码
      },
      // 密码登录表单验证规则
      passwordRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },

      // 验证码登录表单数据
      codeForm: {
        username: "", // 手机号
        verifyCode: "", // 验证码
      },
      // 验证码登录表单验证规则
      codeRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        verifyCode: [
          { required: true, trigger: "blur", validator: validateVerifyCode },
        ],
      },

      // 验证码发送相关数据
      countdown: 60, // 倒计时秒数
      isSending: false, // 是否正在发送验证码
      sendBtnText: "获取验证码", // 发送按钮文本

      loading: false, // 登录按钮加载状态
    };
  },
  methods: {
    // 密码登录处理方法
    handlePasswordLogin() {
      // 表单验证
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.loading = true; // 设置加载状态
          // 调用密码登录API
          pwdLogin({
            phone: this.passwordForm.username, // 用户名/手机号
            pwd: this.passwordForm.password, // 密码
            user_type: 0, // 用户类型，0表示普通用户
          }).then((res) => {
            if (res.status == 200) {
              // 登录成功
              this.loading = false; // 取消加载状态
              this.$message({
                message: "登录成功",
                type: "success",
              });
              // 保存登录状态和token
              setToken("isUserAuth", true);
              setToken("access_token", res.data.token);
              setToken("phone", res.data.phone);
              window.location.href = "/"; // 跳转到首页
            } else {
              // 登录失败
              this.loading = false; // 取消加载状态
              this.$message({
                message: "登录失败,请重新登录",
                type: "error",
              });
            }
          });
        } else {
          return false; // 表单验证失败
        }
      });
    },

    // 验证码登录处理方法
    handleCodeLogin() {
      // 表单验证
      this.$refs.codeForm.validate((valid) => {
        if (valid) {
          this.loading = true; // 设置加载状态
          // 调用验证码登录API
          codeLogin({
            phone: this.codeForm.username, // 手机号
            code: this.codeForm.verifyCode, // 验证码
          }).then((res) => {
            if (res.status == 200) {
              // 登录成功
              this.loading = false; // 取消加载状态
              this.$message({
                message: "登录成功",
                type: "success",
              });
              // 保存登录状态和token
              setToken("isUserAuth", true);
              setToken("access_token", res.data.token);
              setToken("phone", res.data.phone);
              window.location.href = "/"; // 跳转到首页
            } else {
              // 登录失败
              this.loading = false; // 取消加载状态
              this.$message({
                message: "登录失败,请重新登录",
                type: "error",
              });
            }
          });
        } else {
          return false; // 表单验证失败
        }
      });
    },

    // 发送验证码方法
    sendVerifyCode() {
      // 验证手机号
      this.$refs.codeForm.validateField("username", (errorMsg) => {
        if (errorMsg) {
          return; // 手机号验证失败
        }

        // 设置发送状态和倒计时
        this.isSending = true;
        this.countdown = 60;
        this.sendBtnText = `${this.countdown}秒后重新获取`;

        // 调用发送验证码API
        getCaptcha({
          phone: this.codeForm.username, // 手机号
          phone_type: 0, // 手机类型，0表示普通用户
        }).then((res) => {
          if (res.status == 200) {
            // 发送成功
            this.$message({
              message: "验证码已发送",
              type: "success",
            });
            // 开始倒计时
            const timer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--; // 倒计时减1
                this.sendBtnText = `${this.countdown}秒后重新获取`;
              } else {
                // 倒计时结束
                clearInterval(timer);
                this.isSending = false;
                this.sendBtnText = "获取验证码";
              }
            }, 1000);
          } else {
            // 发送失败处理（当前为空）
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.login-container {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.login-form {
  width: 350px;
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.8s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.logo-area {
  position: absolute;
  top: 20px;
  left: 30px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.system-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

/* 登录方式切换 */
.login-tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

.tab-item.active {
  color: #409eff;
  font-weight: 500;
}

.tab-item.active:after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 20%;
  width: 60%;
  height: 2px;
  background: #409eff;
}

.form {
  margin-top: 20px;
}

.verify-code-container {
  display: flex;
}

.verify-code-container .el-input {
  flex: 1;
  margin-right: 10px;
}

.verify-code-container .el-button {
  width: 120px;
  font-size: 12px;
  background: #409eff;
  border-color: #409eff;
}

.verify-code-container .el-button:hover {
  opacity: 0.9;
}

.remember-forgot {
  text-align: right;
  margin-bottom: 20px;
}

.forgot-password {
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
}

.login-button {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  background: #409eff;
  border-color: #409eff;
  transition: all 0.3s;
}

.login-button:hover {
  opacity: 0.9;
}

.register-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.register-link a {
  color: #409eff;
  text-decoration: none;
  margin-left: 5px;
}

.register-link a:hover {
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .decoration-area {
    display: none;
  }

  .login-form-container {
    width: 100%;
  }
}
</style>